export function setPageUtileLoading (state, loading = false) {
  state.pageutileLoading = loading
}

export function setUtile (state, data ) {
  state.items = data.utile.data
  state.utileCurrentPage = data.utile.current_page
  state.utileLastPage = data.utile.last_page
  state.utilePerPage = data.utile.per_page
  state.utileTotal = data.utile.total
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function setSearch (state, search = '') {
  state.search = search
}
